/**
 * Class names games builds from data, on @swtorbit/ui's classes. One place for
 * the status and role colours instead of `badge--status-${status}` in every view
 * (the framework names colours by hue, not by meaning).
 */
/** A status badge's hue. Statuses games never coloured stay the plain badge. */
const STATUS_HUES = {
    active: 'green',
    waiting: 'amber',
    'in-progress': 'blue',
    in_progress: 'blue',
    completed: 'slate',
    created: 'slate',
    cancelled: 'red',
};
/** `badge badge--{hue}` for a game, round or team status. */
export function statusBadgeClass(status, extra = '') {
    const hue = STATUS_HUES[status];
    return ['badge', hue ? `badge--${hue}` : '', extra].filter(Boolean).join(' ');
}
/** Hide and Seek roles: hiders are pink, seekers aqua. */
export function roleHue(role) {
    return role === 'hider' ? 'pink' : role === 'seeker' ? 'aqua' : null;
}
/** `badge badge--{pink | aqua}` for a Hide and Seek role. */
export function roleBadgeClass(role, extra = '') {
    const hue = roleHue(role);
    return ['badge', hue ? `badge--${hue}` : '', extra].filter(Boolean).join(' ');
}
const MEDALS = ['gold', 'silver', 'bronze'];
/** `leaderboard__row` plus the medal modifier for 1st–3rd (index 0–2). */
export function leaderboardRowClass(index) {
    const medal = MEDALS[index];
    return medal ? `leaderboard__row leaderboard__row--${medal}` : 'leaderboard__row';
}
